import { InjectionToken, inject } from '@angular/core';
import { IWrapStore } from './wrap.public';
import { WrapStore } from './wrap.store';

export const WRAP_STORE = new InjectionToken<IWrapStore>('WRAP_STORE', {
    providedIn: 'root',
    factory: () => inject(WrapStore) as IWrapStore,
});
